<template>
  <div
    class="copywrap"
    @mouseover="showHint"
    @mouseleave="hideHint"
    @click="save"
  >
    <el-button
      class="copyButton"
      icon="fas fa-share-alt"
    />
    <div
      ref="copymessage"
      class="copymessage save"
    >
      {{ copyMsg }}
    </div>
    <div class="hintWrapper save">
      <div
        v-if="status"
        class="hintButton save"
      >
        {{ hint }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { hintMixin } from '@/mixins/hint.mixin'
export default {
  name: 'ActionShare',
  mixins: [hintMixin],
  props: {
    hint: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      copyMsg: '',
      loadingConfig: false
    }
  },
  emits: ['changeStorageSettings'],
  computed: {
    ...mapState([
      'uploadedConfig',
      'configUrl'
    ]),
    ...mapGetters({
      spinControlPanelStatus: 'spinControl/spinControlPanelStatus'
    })
  },
  created() {
    this.unwatch = this.$store.watch(
    (state) => {
        return {
          uploadedConfig: state.uploadedConfig,
          configUrl: state.configUrl
        }
      },
    (value) => {
        if (value.uploadedConfig !== null && value.configUrl !== null) {
          const route = process.env.NODE_ENV === 'development' ?
            window.location.host : `https://${window.location.host}/help/viewer`

          const url = this.configUrl.replace('https://sirvwebsite.sirv.com/configs/', '')
          this.loadingConfig = false

          const settingsList = this.$localStorage.get('settingsList')
          if (settingsList !== null) {
            let formattedSettingsList = JSON.parse(settingsList)
            formattedSettingsList.push(`${url}`)
            this.$localStorage.set('settingsList', JSON.stringify(Array.from(new Set(formattedSettingsList))))
          } else {
            this.$localStorage.set('settingsList', JSON.stringify([`${url}`]))
          }

          this.$emit('changeStorageSettings', true)

          this.$copyText(`${route}?config=${url}`)
            .then((e) => {
              this.copyMsg = 'URL copied'
              setTimeout(() => {
                this.copyMsg = ''
              }, 3000)
            }, (e) => {
            console.log(`Can't upload config ${e}`)
          })
        }
      }
    )
  },
  methods: {
    async save() {
      this.status = false
      if (this.loadingConfig) { return }

      this.$emit('changeStorageSettings', false)

      this.loadingConfig = true

      await this.$store.dispatch('resetUploadedConfig')

      await this.$store.dispatch('resetConfigUrl')

      const generatedDate = Date.now()
      const milliseconds = new Date(generatedDate).getMilliseconds()
      const firstPartOptions = {
        day: 'numeric', month: 'numeric', year: 'numeric'
      }
      const lastPartOptions = {
        hour: 'numeric', minute: 'numeric', second: 'numeric',
      }
      const firstPart = new Intl.DateTimeFormat('en-GB',firstPartOptions)
        .format(generatedDate)
        .replace(/\//g, '-')
        .split('-')
        .reverse()
        .join('-')

      const lastPart = new Intl.DateTimeFormat('en-GB',lastPartOptions)
        .format(generatedDate).replace(/:/g, '_')

      let date = `${firstPart}__${lastPart}_${milliseconds}`

      await this.$store.dispatch('uploadConfig', {
        date: date,
        spinControlPanelStatus: this.spinControlPanelStatus
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.copymessage.save {
  min-width: 80px;
  right: -50px;

}
.hintWrapper.save {
  left: -40px;
  @media only screen and (min-width : 767px){
    left: auto;
  }
}
.hintButton.save {
  width: 160px;
}
</style>
